import DetailedRelatedContentWithVisibilityToggle from '@rsa-digital/evo-shared-components/components/RelatedContent/DetailedRelatedContentWithVisibilityToggle';
import { StyledCardGrid } from '@rsa-digital/evo-shared-components/components/RelatedContent/DetailedRelatedContentWithVisibilityToggle/styles';
import { CtaGrid } from '@rsa-digital/evo-shared-components/components/RelatedContent/styles';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const DetailedRelatedContentContainer = styled.div`
  padding-top: ${spacing(3)};
  padding-bottom: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
  `}
`;

export const StyledDetailedRelatedContentWithVisibilityToggle = styled(
  DetailedRelatedContentWithVisibilityToggle
)`
  margin-top: 0;

  h2 {
    margin-top: 0;
  }

  ${StyledCardGrid} {
    margin-bottom: 0;
  }
`;

export const StyledCtaGrid = styled(CtaGrid)`
  padding-top: ${spacing(2)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(1)};
  `}
`;

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
`;
